<template>
    <div class="flex mb-px draggable relative">
        <!-- PO Item. -->
        <div class="flex flex-col flex-1 m-0 relative">
            <div class="flex flex-1 m-0 relative">
                <procurement-resolve-r-f-m-to-p-os-item-select :purchase-orders="purchaseOrders"
                                                               :RFMItem="RFMItem"
                                                               ref="poItemSelect"
                                                               @selected:item="itemSelected"
                                                               #default="{ close, open, query, setQuery }"
                                                               class="flex flex-1 m-0 -ml-px -mt-px -mr-px -mb-px bg-white border-l border-t border-b border-gray-200 shadow-none min-w-24">
                    <page-cell
                        class="text-sm -my-px -ml-px px-1 py-1.5 border border-gray-200"
                        placeholder="Search for PO Item..."
                        ref="poItem"
                        v-if="searching"
                        v-model="search"
                        @input="searching = true;setQuery(search)"
                        @focus="searching = true;setQuery(search);open(true)"
                        @blur="applyItem(close)"
                    ></page-cell>
                    <div v-else-if="resolve.purchaseOrderId" @click="editMe()" class="text-xs pl-1 pt-2 text-gray-500"
                         v-text="findItemText()">
                    </div>
                    <div v-else @click="editMe()" class="text-xs pl-1 pt-2 text-gray-300 italic">
                        &lt;No Purchase Order Item&gt;
                    </div>
                </procurement-resolve-r-f-m-to-p-os-item-select>
                <div class="w-28 -ml-px flex">
                    <page-cell
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Qty..."
                        ref="quantity"
                        v-model="resolve.quantity"
                        @input="updateQuantity(false)"
                        @blur="updateQuantity(true)"
                    ></page-cell>
                </div>
            </div>
        </div>
        <div class="w-6 flex-shrink-0 bg-white border-t -mt-px border-gray-200">
            <ui-dropdown menu-class="p-3 w-72">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded mt-1.5">
                        <i class="fa fa-ellipsis-h fa-fw pl-1 pr-1"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <template>
                        <ui-dropdown-item icon="fas fa-trash" danger
                                          @click="$emit('removeItem',resolve);close();">
                            Remove Resolution
                        </ui-dropdown-item>
                    </template>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>

import PageCell from "../../ui/PageCell.vue";
import moment from "moment";
import UiDropdown from "../../ui/UiDropdown.vue";
import ProcurementResolveRFMToPOsItemSelect from "./ProcurementResolveRFMToPOsItemSelect.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";

export default {
    components: {
        UiDropdownItem,
        ProcurementResolveRFMToPOsItemSelect,
        UiDropdown,
        PageCell
    },
    props: {
        resolve: Object,
        purchaseOrders: Array,
        RFMItem: Object,
    },
    data() {
        return {
            search: "",
            searching: false,
            moment: moment,
        }
    },
    watch: {},
    computed: {},
    methods: {
        findItemText() {
            let po = this.purchaseOrders.find((i) => i.id == this.resolve.purchaseOrderId);
            if (po) {
                let item = po.items.find((i) => i.id == this.resolve.purchaseOrderItemId);
                if (item) {
                    return po.supplier + ' ' + po.fullReference + ' - Item ' + (po.items.indexOf(item) + 1) + ' - ' + item.description + ' (' + item.quantity + ' ' + item.unitOfMeasure + ')';
                }
            }
            return 'Unknown PO/Item - maybe deleted?';
        },
        updateQuantity(finished) {
        },
        applyItem(close) {
            this.searching = false;
            close();
        },
        itemSelected(po, item) {
            this.resolve.purchaseOrderId = po.id;
            this.resolve.purchaseOrderItemId = item.id;
            if (this.RFMItem.uom === this.resolve.unitOfMeasure) {
                this.resolve.quantity = item.quantity;
            } else {
                this.resolve.quantity = 0;
            }
            this.searching = false;
        },
        editMe() {
            this.searching = true;
            this.$nextTick(() => this.$refs.poItem.focusAsNew())
        },
    },
    mounted() {
    }
}
</script>